import styled from "styled-components";

import {
  BREAKPOINT,
  COLORS,
  FONT_WEIGHT,
  paragraphStyles,
} from "../../constants/Styles";

export const Container = styled.div`
  width: ${BREAKPOINT};
  padding: 0 1rem;
  @media (max-width: ${BREAKPOINT}) {
    width: 100%;
  }
`;

export const Header = styled.div`
  text-align: center;
`;

export const Paragraph = styled.p`
  ${paragraphStyles};
  margin-bottom: 2rem;

  > span {
    color: ${COLORS.secondary};
  }

  > .emphasized {
    font-weight: ${FONT_WEIGHT.weight700};
  }
`;
